import { observer } from 'mobx-react-lite'
import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'
import { byDesign } from '@/infra/design'
import { type DeleteJobDocumentsDialogViewModel } from '@/features/jobs/details/components/DeleteJobDocumentsDialog/DeleteJobDocumentsDialogViewModel'
import imgRemoveCollaboratorUrl from '@/assets/misc/img_remove-collaborator.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface DeleteJobDocumentsDialogContainerProps {
  vm: DeleteJobDocumentsDialogViewModel
  /**
   * Words the confirmation for deleting several documents.
   */
  multiple?: boolean
}

export const DeleteJobDocumentsDialogContainer = observer(
  function DeleteJobDocumentsDialogContainer({
    vm,
    multiple,
  }: DeleteJobDocumentsDialogContainerProps) {
    return (
      <ConfirmSheet
        yes="Delete Forever"
        danger
        showing={vm.modal.showing}
        isPending={vm.delete.pending}
        onConfirm={vm.delete}
        onDecline={vm.modal.close}
      >
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgRemoveCollaboratorUrl}
            illustration={byDesign(undefined, DocumentsDisabledIllustration)}
            alt="Illustration of a women holding a phone with a crossed-out bubble above the phone."
          />
          <ModalSheetContentTitle>
            {multiple
              ? 'Are you sure you want to delete these files?'
              : 'Are you sure you want to delete this file?'}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            {multiple
              ? 'This action cannot be undone. Are you sure that you want to permanently delete these documents?'
              : 'This action cannot be undone. Are you sure that you want to permanently delete this document?'}
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ConfirmSheet>
    )
  },
)
